import * as React from 'react'

import formatPrice from '../../../../common/utils/formatPrice'

import * as styles from './lockupPrice.module.css'

const LockupPrice = ({
  priceInCents,
  originalPriceInCents
}: {
  priceInCents: number
  originalPriceInCents?: number
}) => {
  if (originalPriceInCents) {
    return (
      <div className={styles.root}>
        <span className={styles.originalPrice}>
          ${formatPrice(originalPriceInCents)}
        </span>
        <span className={styles.promoPrice}>${formatPrice(priceInCents)}</span>
      </div>
    )
  } else {
    return <div className={styles.root}>${formatPrice(priceInCents)}</div>
  }
}

export default LockupPrice
